import { useState, useEffect, useRef } from 'react';
import '../css/ShowAllComponent.css';
import { useNavigation } from '../function/navigation';

function ShowAllComponent() {
  const [showOptions, setShowOptions] = useState(false);
  const menuRef = useRef(null);

  const { nav, dispatch } = useNavigation();

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setShowOptions(false);
    }
  };

  useEffect(() => {
    if (showOptions) {
      document.addEventListener('mousedown', handleClickOutside, {
        passive: true,
      });
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showOptions]);

  return (
    <div className="show-all-container" ref={menuRef}>
      {showOptions && (
        <div className="floating-options-menu">
          <p className="show-details">Show options</p>
          <div className="show-setting-options">
            {['all', 'selectable', 'priced'].map((option) => (
              <div
                key={option}
                className="show-setting-option"
                onClick={() =>
                  dispatch({ type: 'showOptions', payload: option })
                }
              >
                <input
                  type="radio"
                  name="show-options"
                  value={option}
                  checked={nav.showOptions === option}
                  onChange={() => {}}
                  readOnly
                />
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="show-all-container-left-column">
        <button className="settings-button" onClick={toggleOptions}>
          <img
            src={`${process.env.PUBLIC_URL}/icons/setting.png`}
            alt="Settings"
            className="settings-icon"
          />
        </button>
      </div>
    </div>
  );
}

export default ShowAllComponent;
